module.exports = __webpack_public_path__ + "0c239afdc9a3aa0e329a24abf355cca2.svg";